export default __webpack_public_path__ + "img/app-page/screen1.cee84cb8c6d9530dac3409d5dca7a140.png";